import gql from 'graphql-tag';

import cardElementDetails from './cardElementDetails';

const cardTemplateDetails = gql`
  fragment cardTemplateDetails on CardTemplate {
    id
    side
    name
    orientation
    card_elements {
      ...cardElementDetails
    }
    print_product {
      id
      name
      print_size {
        id
        name
        width
        height
      }
      print_partner {
        id
        name
      }
      sizes(slice: { limit: 999 }) {
        records {
          id
          print_size {
            id
          }
          price {
            value
            currency
          }
          min_price {
            value
            currency
          }
        }
      }
    }
    print_size {
      id
      name
      width
      height
    }
  }
  ${cardElementDetails}
`;

export default cardTemplateDetails;
